import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class VendorAccountRawDto {
    id: number; // NOTE: Vendor account id required for editing existing vendor account
    associationVendorId: number;
    accountNumber: string; // NOTE: Max 50 characters
    active: boolean;
    description: string; // NOTE: Max 200 characters
    authorizedUsers: string; // NOTE: Max 200 characters
    hasNotes: boolean; // NOTE: Used for display purpose only for notes icon
    isEFTOffered: boolean;
    eftActive: boolean;
    eftInactiveReason: string; // NOTE: Max 200 characters. Should be on of the EFTInactiveReasons key value provided in the editor result
    bankAccountId: number;
    eftWebsite: string; // NOTE: Max 200 characters
    eftUserName: string; // NOTE: Max 100 characters
    eftPassword: string; // NOTE: Max 50 characters
    agreeToVendorTerms: boolean;
    chargesLateFeeOrFinanceCharge: boolean;
    willTerminateOrDisconnect: boolean;
    billingFrequency: string; // NOTE: Max 10 characters. Should be one of the BillingFrequencies key value provided in the editor result
    billingFrequencyValue: string; // NOTE: Max 10 characters. Used mainly for AdHoc frequency
    accountBillingStatus: string; // NOTE: Max 50 characters. Should be one of the AccountBillingStatuses key value provided in the editor result

    @Type(() => UserNameDisplayResultDto)
    statusLastUpdatedBy: UserNameDisplayResultDto;

    @Type(() => Date)
    statusLastUpdated: Date; // NOTE: Is in UTC time zone. Will need to convert to user preference time zone and display date and time
}
